import React, { useState, useEffect, useContext, useRef } from "react";
import makeStyles from '@mui/styles/makeStyles';
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import PrescriptionForm from "./PrescriptionForm";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as api from "../../../actions/api";
import { useTranslation } from "react-i18next";

//Import Preloader
import LoadingSpinnerOpaque from "services/LoadingSpinnerOpaque";

import { UserContext } from "../../../context/user-info-context";

const AddPrescription = (props) => {
  const userCtx = useContext(UserContext);

  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  ); //get DispensingLanguage
  const menukey = "prescriptions";

  // const lan = userCtx.userInfo.LangId; //"fr_FR";
  const lan = localStorage.getItem("LangCode");
  // const lan = "fr_FR";
  const { t, i18n } = useTranslation();
  const [controlLoading, setControlLoading] = useState(false);

  // const [isLoadingForm, setLoadingForm] = useState(false);

  // const [isLoadingForm, setLoadingForm] = useState(false);

  const [formData, setFormData] = useState({
    id: "",
    demander: "",
    prescriber: "",
    ClinicId: "",
    dispenser: "",
    patientId: "",
    prescriptionDate: new Date(),
    appointmentDate: null,
    prescriptionNumbar: "",
    patientIdNumber: "",
    ipn: "",
    idNumber: "",
    referred: false,
    new: false,
    pregnant: false,
    status: -1,
    ICDCode: "",
    cost: "0",
    finalCost: "0",
    packs: "1",
    batchId: "",
    details: [],
    repeats: "0",
    ProtocolId: "",
    RegimenId: "",
    ExistingProtocolId: "",
    deletedDataSet: "",
    MaxDur: "",
    Remarks: "",
    RepeatFromPrescriptionId: "",
    currentDate: new Date(),
  });

  const [patientData, setPatientData] = useState({
    id: "",
    productCode: "",
    productName: "",
    icn: "",
    genericName: "",
    tradeName: "",
    ecn: "",
    strengthSize: "",
    price: "",
    ven: "",
    nsn: "",
    form: "",
    routeOfAdmin: "",
    abc: "",
    fin: "",
    packSize: "",
    unit: "",
    atc: "",
    rxLevel: "",
    productType: "",
    administrationUnit: "",
    pediatric: false,
    injectable: false,
    binLocation: "",
    markUp: "",
    sellingPrice: "",
    shippingPack: "",
    productDescription: "",
    includeTradenameinDescription: false,
    excludeGenericnamefromDescription: false,
    availableforDispensing: false,
    breakAdministrationUnit: false,
  });

  const queryClient = useQueryClient();
  const { id } = useParams();

  const [errorObject, setErrorObject] = useState({});

  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedProtocols, setSelectedProtocols] = useState([]);
  const [showProductListModel, setShowProductListModel] = useState(false);
  const [showProtocolListModel, setShowProtocolListModel] = useState(false);
  const [btnStatus, setBtnStatus] = useState("");
  const saveInFlightRef = useRef(false);

  const IntervalList = JSON.parse(localStorage.getItem("IntervalList"));

  const { data, refetch } = useQuery(
    ["prescription", id],
    () =>
      api.getPrescription(id).then((res) => {
        console.log('ressssssssss: ', res);
        //This is for user has VIEW/EDIT permission in this page start
        if (props.permissionType === 1) {
          //when permissionType then it is only VIEW permission otherwise normal permission
          res.status = 1;
        }
        //This is for user has VIEW/EDIT permission in this page end

        console.log("getPrescription Edit by id", res);
        setFormData(res);
        console.log("getPrescription formData: ", formData);

        let selectedProductIds = [];
        let selectedProtocolIds = [];
        res.details.map((detail) => {
          if (detail.type == "product") {
            selectedProductIds.push(detail.productId);
          }
        });
        res.details.map((detail) => {
          if (detail.type == "protocol") {
            selectedProtocolIds.push(detail.protocolId);
          }
        });
        setSelectedProducts(selectedProductIds);
        setSelectedProtocols(selectedProtocolIds);
        return res;
      }),

    {
      refetchOnWindowFocus: false,
      // enabled: false // turned off by default, manual refetch is needed
      enabled: Boolean(id),
    }
  );

  const updatePrescriptionMutate = useMutation(api.updatePrescription, {
    onSuccess: (data) => {
      // console.log('updatePrescriptionMutate data: ', data.data.success);

      if (data.data.success === 1) {
        queryClient.setQueriesData(["prescriptions", formData.id], data);

        // console.log('btnStatus when press on update button: ', btnStatus);
        // console.log('updatePrescriptionMutate formData: ', formData);

        let pdata = {};
        pdata["id"] = formData.id;
        pdata["status"] = btnStatus;
        pdata["patientIdNumber"] = formData.patientIdNumber;
        pdata["idNumber"] = formData.idNumber;
        pdata["ipn"] = formData.ipn;
        pdata["repeats"] = formData.repeats;
        pdata["currentDate"] = formData.currentDate;
        pdata["patientId"] = formData.patientId;
        pdata["demander"] = formData.demander;

        if (btnStatus === "Posted") {
          postPrescriptionMutate.mutate(pdata);
        } else if (btnStatus === "Copy") {
          updatePrescriptionCopyMutate.mutate(pdata);
        } else if (btnStatus === "Stop") {
          console.log("Normal update success and Stop calling");
          updatePrescriptionStatusMutate.mutate(pdata);
        } else if (btnStatus === "NotCollected") {
          console.log("Normal update success and Not collected calling");
          updatePrescriptionStatusMutate.mutate(pdata);
        } else {
          console.log("Normal update success");
          //when normal update
          props.openNoticeModal({
            isOpen: true,
            msg: data.data.message,
            msgtype: 1,
          });

          refetch();
          setControlLoading(false);

          // swal(
          //   t(DispensingLanguage[lan][menukey]["success"]),
          //   {
          //     icon: "success",
          //   }
          // );
        }
      } else {
        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: 0,
        });
        setControlLoading(false);
      }

      setBtnStatus("");
    },
  });

  const updatePrescriptionStatusMutate = useMutation(
    api.updatePrescriptionStatus,
    {
      onSuccess: (data) => {
        if (data.data.success === 1) {
          if (btnStatus === "Stop") {
            // swal(
            //   t(DispensingLanguage[lan][menukey]["Poof! Prescription has been canceled/stoped!"]),
            //   {
            //     icon: "success",
            //   }
            // );
            console.log("Stop call success");
            props.openNoticeModal({
              isOpen: true,
              msg: t(
                DispensingLanguage[lan][menukey][
                  "Poof! Prescription has been canceled/stoped!"
                ]
              ),
              msgtype: 1,
            });
          } else if (btnStatus === "NotCollected") {
            // swal(
            //   t(DispensingLanguage[lan][menukey]["Poof! Prescription has been not collected!"]),
            //   {
            //     icon: "success",
            //   }
            // );
            console.log("NotCollected call success");
            props.openNoticeModal({
              isOpen: true,
              msg: t(
                DispensingLanguage[lan][menukey][
                  "Poof! Prescription has been not collected!"
                ]
              ),
              msgtype: 1,
            });
          }

          refetch();
          queryClient.setQueriesData(["prescriptions", formData.id], data);
        } else {
          props.openNoticeModal({
            isOpen: true,
            msg: data.message,
            msgtype: 0,
          });
          // swal(
          //   "Failled!!",
          //   {
          //     icon: "error",
          //   }
          // );
        }

        setControlLoading(false);
      },
    }
  );

  const postPrescriptionMutate = useMutation(api.postPrescription, {
    onSuccess: (data) => {
      if (data.data.success === 1) {
        // console.log('data.status: ', data.status);

        props.openNoticeModal({
          isOpen: true,
          msg: t(
            DispensingLanguage[lan][menukey][
              "Poof! Prescription has been posted!"
            ]
          ),
          msgtype: 1,
        });

        refetch();
        queryClient.setQueriesData(["prescriptions", formData.id], data);
        // swal(
        //   t(DispensingLanguage[lan][menukey]["Poof! Prescription has been posted!"]),
        //   {
        //     icon: "success",
        //   }
        // );
      } else {
        // console.log('data.status fail: ', data.status);
        // console.log("data.message: ",data.data.message);
        //  swal(data.data.message, "", "error");
        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: 0,
        });
      }
      setControlLoading(false);
    },
  });

  const updatePrescriptionCopyMutate = useMutation(api.updatePrescriptionCopy, {
    onSuccess: (data) => {
      if (data.data.success == 1) {
        props.openNoticeModal({
          isOpen: true,
          msg: t(
            DispensingLanguage[lan][menukey][
              "Poof! Prescription has been copied!"
            ]
          ),
          msgtype: 1,
        });

        refetch();
        queryClient.setQueriesData(["prescriptions", formData.id], data);
        // swal(
        //   t(DispensingLanguage[lan][menukey]["Poof! Prescription has been copied!"]),
        //   {
        //     icon: "success",
        //   }
        // );
      } else {
        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: 0,
        });

        // swal(
        //   data.data.message,
        //   {
        //     icon: "error",
        //   }
        // );
      }
      setControlLoading(false);
    },
  });

  const isSubmitting =
    updatePrescriptionMutate.isLoading ||
    postPrescriptionMutate.isLoading ||
    updatePrescriptionStatusMutate.isLoading ||
    updatePrescriptionCopyMutate.isLoading;

  const handleDateChange = (date) => {};

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    setErrorObject({ ...errorObject, [name]: null });
  };

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
  };

  const handleRDateChange = (date, field) => {
    console.log("date, field: ", date, field);
    setFormData({ ...formData, [field]: date });
    setErrorObject({ ...errorObject, [field]: null });
  };

  const handleDetailChange = (e, rowData) => {
    let data = { ...formData };
    let details = [...formData.details];
    const { name, value } = e.target;

    details = details.map((detail) => {
      if (detail.id == rowData.id) {
        detail[name] = value;
      }
      return detail;
    });
    data["details"] = details;
    setFormData(data);
  };

  const handleDetailDropDownChange = (e, rowData) => {
    // console.log("Product before update rows when dropdown change in edit page: ",rowData);
    let data = { ...formData };
    let details = [...formData.details];
    const { name, value } = e.target;

    details = details.map((detail) => {
      if (detail.id == rowData.id) {
        detail[name] = value;

        // console.log("IntervalList: ",IntervalList);
        // console.log("cur intervalId: ",rowData.intervalId);

        const curInvervalValueObj = IntervalList.filter((intervalRow) => {
          if (rowData.intervalId == intervalRow.id) {
            return intervalRow;
          }
        });
        // console.log("curInvervalValueObj: ",curInvervalValueObj);
        // console.log("curInvervalValue: ",curInvervalValueObj[0].value);

        let calcQty =
          detail["dur"] * curInvervalValueObj[0].value * detail["qty"];
        detail["calc"] = calcQty;

        // let tmpPcks = Math.ceil(calcQty/detail['PacksizeName']);
        // detail['pcks'] = tmpPcks;
        // detail['dispQty'] = tmpPcks*detail['PacksizeName'];
      }
      return detail;
    });

    // console.log(      "Product updated rows when dropdown change in edit page: ",      details    );
    data["details"] = details;
    setFormData(data);
  };

  const handleDetailCheck = (e, rowData) => {
    let data = { ...formData };
    let details = [...formData.details];
    const { name, checked } = e.target;

    details = details.map((detail) => {
      if (detail.id == rowData.id) {
        detail[name] = checked;
      }
      return detail;
    });
    data["details"] = details;
    setFormData(data);
  };

  const setUpdatedDetailsGridDataHandler = (rows, curcol) => {
    // console.log("setUpdatedDetailsGridDataHandler");
    if (curcol === "qty" || curcol === "dur" || curcol === "pcks") {
      // console.log("Product before updated rows in edit page: ", rows);
      // console.log("Edited column: ", curcol);

      let data = { ...formData };
      let ManyTableData = data["details"];

      const updateManyTableData = ManyTableData.map((row) => {
        // if (row.SKU == rows.SKU) {
        if (row.id == rows.id) {
          if (curcol === "qty" || curcol === "dur") {
            // console.log("IntervalList: ",IntervalList);
            // console.log("cur intervalId: ",rows.intervalId);

            const curInvervalValueObj = IntervalList.filter((intervalRow) => {
              if (rows.intervalId == intervalRow.id) {
                return intervalRow;
              }
            });
            // console.log("curInvervalValueObj: ",curInvervalValueObj);
            // console.log("curInvervalValue: ",curInvervalValueObj[0].value);

            row.qty = rows.qty;
            row.dur = rows.dur;
            row.rep = rows.rep;
            let calcQty = rows.dur * curInvervalValueObj[0].value * rows.qty;
            row.calc = calcQty;

            // let tmpPcks = Math.ceil(calcQty/rows.PacksizeName);
            // row.pcks = tmpPcks;
            // row.dispQty = tmpPcks*rows.PacksizeName;
          } else if (curcol === "pcks") {
            let calDispQty = "";
            if (rows.pcks > 0) {
              calDispQty = rows.PacksizeName * rows.pcks;
            }
            row.dispQty = calDispQty;
          }
        }

        return row;
      });
      data["details"] = updateManyTableData;

      // console.log("Product updated rows in edit page: ", updateManyTableData);
      setFormData(data);
    }
  };

  const handleProductAdd = (NonOrderProductData) => {
    let data = { ...formData };

    data["details"] = NonOrderProductData;
    setFormData(data);

    console.log("Add product in edit page: ", data);
    // setManyTableData(NonOrderProductData)
  };

  const handleReset = () => {
    setFormData({
      id: "",
      demander: "",
      prescriber: "",
      ClinicId: "",
      dispenser: "",
      patientId: "",
      prescriptionDate: new Date(),
      appointmentDate: null,
      prescriptionNumbar: "",
      patientIdNumber: "",
      ipn: "",
      idNumber: "",
      referred: false,
      new: false,
      pregnant: false,
      status: -1,
      ICDCode: "1",
      cost: 0,
      finalCost: 0,
      packs: "",
      batchId: "",
      details: [],
      repeats: "0",
      ProtocolId: "",
      RegimenId: "",
      //ExistingProtocolId: "",
      deletedDataSet: "",
      MaxDur: "",
      Remarks: "",
      RepeatFromPrescriptionId: "",
      currentDate: new Date(),
    });
  };

  const validateForm = (formData) => {
    let validateFields = ["dispenser", "prescriber", "prescriptionDate"];
    let errorData = {};
    let isValid = true;
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] =
          t(DispensingLanguage[lan][menukey]["field is Required !"]);
        isValid = false;
      }
    });
    setErrorObject(errorData);
    return isValid;
  };

  const updatePrescription = async (e) => {
    if (saveInFlightRef.current || isSubmitting) {
      return;
    }
    let data = { ...formData };
    if (validateForm(formData)) {
      if (formData.details.length === 0) {
        // swal(
        //   t(DispensingLanguage[lan][menukey]["There are no prescription details"]),
        //   {
        //     icon: "error",
        //   }
        // );
        props.openNoticeModal({
          isOpen: true,
          msg: t(
            DispensingLanguage[lan][menukey][
              "There are no prescription details"
            ]
          ),
          msgtype: 0,
        });
        setControlLoading(false);
      } else {
        saveInFlightRef.current = true;
        setControlLoading(true);
        updatePrescriptionMutate.mutate(data, {
          onSettled: () => {
            saveInFlightRef.current = false;
          },
        });
      }
    } else {
      setControlLoading(false);
    }
  };

  const changePrescriptionStatus = (status) => {
    if (saveInFlightRef.current || isSubmitting) {
      return;
    }
    setControlLoading(true);
    // console.log('changePrescriptionStatus formData: ', formData);

    // let data = {};
    // data["id"] = formData.id;
    // data["status"] = status;
    // data["patientIdNumber"] = formData.patientIdNumber;
    // data["repeats"] = formData.repeats;
    // data["currentDate"] = formData.currentDate;

    if (status === "Copy") {
      swal({
        title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
        text: t(
          DispensingLanguage[lan][menukey][
            "You want to copy this prescription!"
          ]
        ),
        icon: "warning",
        buttons: [
          t(DispensingLanguage[lan][menukey]["No"]),
          t(DispensingLanguage[lan][menukey]["Yes"]),
        ],
        dangerMode: true,
      }).then((willAction) => {
        if (willAction) {
          setBtnStatus("Copy");
          updatePrescription(); //call save
        } else {
          setControlLoading(false);
        }
      });
    } else if (status === "Stop") {
      swal({
        title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
        text: t(
          DispensingLanguage[lan][menukey][
            "You want to cancel/stop this prescription!"
          ]
        ),
        icon: "warning",
        buttons: [
          t(DispensingLanguage[lan][menukey]["No"]),
          t(DispensingLanguage[lan][menukey]["Yes"]),
        ],
        dangerMode: true,
      }).then((willAction) => {
        if (willAction) {
          setBtnStatus("Stop");
          updatePrescription(); //call save

          // swal(
          //   t(
          //     DispensingLanguage[lan][menukey][
          //       "Poof! Prescription has been canceled/stoped!"
          //     ]
          //   ),
          //   {
          //     icon: "success",
          //   }
          // );
        } else {
          setControlLoading(false);
        }
      });

      // updatePrescriptionStatusMutate.mutate(data);
      // swal("Success!", "", "success");
    } else if (status === "NotCollected") {
      swal({
        title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
        text: t(
          DispensingLanguage[lan][menukey][
            "You want to not collected this prescription!"
          ]
        ),
        icon: "warning",
        buttons: [
          t(DispensingLanguage[lan][menukey]["No"]),
          t(DispensingLanguage[lan][menukey]["Yes"]),
        ],
        dangerMode: true,
      }).then((willAction) => {
        if (willAction) {
          // updatePrescriptionStatusMutate.mutate(data);

          setBtnStatus("NotCollected");
          updatePrescription(); //call save

          // swal(
          //   t(
          //     DispensingLanguage[lan][menukey][
          //       "Poof! Prescription has been not collected!"
          //     ]
          //   ),
          //   {
          //     icon: "success",
          //   }
          // );
        } else {
          setControlLoading(false);
        }
      });

      // updatePrescriptionStatusMutate.mutate(data);
      // swal("Success!", "", "success");
    } else if (status === "Posted") {
      if (
        formData["appointmentDate"] == "" ||
        formData["appointmentDate"] == null ||
        formData["appointmentDate"] == "null"
      ) {
        props.openNoticeModal({
          isOpen: true,
          msg: t(
            DispensingLanguage[lan][menukey][
              "Please Fill Up Next Appointment Date"
            ]
          ),
          msgtype: 0,
        });

        setControlLoading(false);
        return;
      }

      // console.log("formData: ", formData);
      let isUnlinkProduct = 0;
      formData.details.forEach((row, i) => {
        console.log("row: ", row.nd);
        if (!row.productId && row.nd == 0) {
          isUnlinkProduct = 1;
        }
      });

      if (isUnlinkProduct) {
        props.openNoticeModal({
          isOpen: true,
          msg: t(
            DispensingLanguage[lan][menukey]["Link batch for each products"]
          ),
          msgtype: 0,
        });
        setControlLoading(false);
      } else {
        console.log("controlLoading", controlLoading);
        swal({
          title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
          text: t(
            DispensingLanguage[lan][menukey][
              "Once posted, you will not be able to unpost this Prescription!"
            ]
          ),
          icon: "warning",
          buttons: [
            t(DispensingLanguage[lan][menukey]["No"]),
            t(DispensingLanguage[lan][menukey]["Yes"]),
          ],
          dangerMode: true,
        }).then((willAction) => {
          if (willAction) {
            setBtnStatus("Posted");
            updatePrescription(); //call save
          } else {
            setControlLoading(false);
          }
        });
      }

      // postPrescriptionMutate.mutate(data);
      // swal("Success!", "", "success");
    } else {
      // swal("Fail!", "", "error");

      props.openNoticeModal({
        isOpen: true,
        msg: "Fail!",
        msgtype: 0,
      });
      setControlLoading(false);
    }
  };

  useEffect(() => {}, [formData]);

  return (
    <div>
      {/* {1==1 && <LoadingSpinnerOpaque />} */}

      <PrescriptionForm
        setFormData={setFormData}
        AddRecord={false}
        patientData={patientData}
        formData={formData}
        handleChange={handleChange}
        handleDateChange={handleDateChange}
        handleCheck={handleCheck}
        updatePrescription={updatePrescription}
        handleReset={handleReset}
        handleRDateChange={handleRDateChange}
        showProductListModel={showProductListModel}
        setShowProductListModel={setShowProductListModel}
        // productList = {getProductsMutate.data}
        // protocolList = {getProtocolMutate.data}
        // productList={getProductsMutate}
        // protocolList={getProtocolMutate}
        changePrescriptionStatus={changePrescriptionStatus}
        handleDetailChange={handleDetailChange}
        handleDetailDropDownChange={handleDetailDropDownChange}
        handleDetailCheck={handleDetailCheck}
        selectedProducts={selectedProducts}
        setSelectedProducts={setSelectedProducts}
        selectedProtocols={selectedProtocols}
        setSelectedProtocols={setSelectedProtocols}
        showProtocolListModel={showProtocolListModel}
        setShowProtocolListModel={setShowProtocolListModel}
        errorObject={errorObject}
        productAdd={handleProductAdd}
        setUpdatedDetailsGridDataHandler={setUpdatedDetailsGridDataHandler}
        controlLoading={controlLoading}
        permissionType={props.permissionType}
        {...props}
        isSubmitting={isSubmitting}
      />
    </div>
  );
};

export default AddPrescription;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
  th: {
    "border-left": "1px solid red",
  },
});
